import { HedgingSettings, BulkHedgingSettings, BulkHedgingSettingsForAllLocations } from "./hedgingSettings";
import HedgingConfiguration from "./hedgingConfiguration"
import Throttle from "common/decorators/throttle";
import HttpService from "common/http/httpService";

class HedgingService extends HttpService {

    async listHedgings(): Promise<HedgingSettings[]> {
        const response = await this.getClient().get<HedgingSettings[]>('/settings/v1/hedgings');
        return response.data;
    }

    @Throttle(1000, true)
    async getHedgingConfiguration(): Promise<HedgingConfiguration> {
        const response = await this.getClient().get<HedgingConfiguration>(
            "/settings/v1/configuration/hedging"
        );
        return response.data;
    }

    async updateHedgingSetting(hedgingSetting: HedgingSettings): Promise<void> {
        await this.getClient().put<HedgingSettings>(
            '/settings/v1/hedging', hedgingSetting
        );
    }

    async updateBulkHedgingSetting(bulkHedgingSetting: BulkHedgingSettings): Promise<void> {
        await this.getClient().put<BulkHedgingSettings>(
            '/settings/v1/hedging/bulk', bulkHedgingSetting
        );
    }

    async updateBulkHedgingSettingAllLocations(bulkHedgingSettingsForAllLocations: BulkHedgingSettingsForAllLocations): Promise<void> {
        await this.getClient().put<BulkHedgingSettingsForAllLocations>(
            '/settings/v1/hedging/bulk/all', bulkHedgingSettingsForAllLocations
        );
    }
}
const hedgingsService = new HedgingService();
export default hedgingsService;
